// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608141004/js/" + chunkId + "." + {"44":"135be10a","225":"1154d37c","481":"5f89803a","486":"d78d6bb8","770":"a0ef6fef"}[chunkId] + ".0.6328736099652269.chunk.js";
};